import React from 'react';
import { StyledLinearProgress } from './styles';

export const LinearProgress = ({ height, ...rest }) => (
  <StyledLinearProgress
    variant='determinate' data-testid='linear-progress' height={height} {...rest}
  />
);
